import axios from "axios";

export async function submitIdentityDetail({
  aadhar_number,
  pan_number,
  voter_id,
  passport_number,
  driving_license,
},id, isUpdate) {

  if(isUpdate) {
     return await axios.patch(`/api/employees/update-identity-details?_id=${id}`, {
        aadhar_number,
        pan_number,
        voter_id,
        passport_number,
        driving_license,
      });
  }else {
    return await axios.post("/api/employees/identity-details", {
        aadhar_number,
        pan_number,
        voter_id,
        passport_number,
        driving_license,
      });
  }
 
 
}

export async function submitJobDetailApi({
  department,
  designation,
  employee_id,
  location,
  date_of_joining,
  employee_type,
  work_location,
  reporting_manager_id,
},id, isUpdate) {
  if(isUpdate) {
  return await axios.patch(`/api/employees/update-job-details?_id=${id}`, {
       department,
    designation,
    employ_id: employee_id,
    location,
    date_of_joining,
    employee_type,
    work_location,
    reporting_manager_id,
      });
  }else {
     return await axios.post("/api/employees/job-details", {
    department,
    designation,
    employ_id: employee_id,
    location,
    date_of_joining,
    employee_type,
    work_location,
    reporting_manager_id,
  });
  }
 
}

export async function submitHistoryApi(value,id,isUpdate) {
  const payload = value?.map((item) => ({
    organization_name: item.organization_name,
    designation: item.designation,
    from_date: item.duration?.[0],
    to_date: item.duration?.[1],
    reason_for_leaving: item.reason_for_leaving,
  }));

  if(isUpdate) {
      return await axios.patch(`/api/employees/update-employment-history?_id=${id}`, {
    employment: payload,
  });
  }else {
      return await axios.post("/api/employees/employment-history", {
    employment: payload,
  });
  }

}

export async function submitRefferenceApi(value,id,isUpdate) {
  const payload = value?.map((item) => ({
    name: item.name,
    employee_code: item.employee_code,
    work_location: item.work_location,
    company_name: item.company_name,
    contact_number: item.contact_number,
  }));


   if(isUpdate) {
      return await axios.patch(`/api/employees/reference-details?_id=${id}`, {
    employment: payload,
  });
  }else {
      return await axios.post("/api/employees/reference-details", {
    references: payload,
  });
  }
  
}

export async function submitEsicDetailApi({
  is_covered,
  esic_number,
  dispensary_address,
},id, isUpdate) {
  if(isUpdate) {
     return await axios.patch(`/api/employees/update-esic-details?_id=${id}`, {
    is_covered,
    esic_number,
    dispensary_address,
  });
  }else {
     return await axios.post("/api/employees/esic-details", {
    is_covered,
    esic_number,
    dispensary_address,
  });
  }
 
}

export async function submitPfDetailApi({
  uan_number,
  pf_transfer_required,
  pf_number,
},id,isUpdate) {
  if(isUpdate) {
    return await axios.patch(`/api/employees/update-pf-details?_id=${id}`, {
        uan_number,
        pf_transfer_required,
        pf_number: pf_number,
      });
  }else {
     return await axios.post("/api/employees/pf-details", {
        uan_number,
        pf_transfer_required,
        pf_number: pf_number,
      });
  }
  
}

export async function confirmOrRejectAppointment({ accept, reject, reason }) {
  return await axios.post("/api/employees/accept-reject", {
    accept,
    reject,
    reason,
  });
}
